import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {
  View,
  Share,
  Platform,
  useWindowDimensions,
  Pressable,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {WebView} from 'react-native-webview';

import Text from '../../components/elements/Text';
import IconButton from '../../components/elements/IconButton';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../theme';
import {fetchApi} from '../../utils/ApiHelper';
import {
  FAV_A_RESOURCE,
  UNFAV_A_RESOURCE,
  HTTP_METHODS,
} from '../../utils/URLConstants';
import {DLog} from '../../utils/HelperMethods';
import {
  useNavigate,
  useLocation,
  useOutletContext,
} from '../../utils/mockedWebLibs/react-router-dom';
import CommonStyles from '../../utils/CommonStyles';
import {RWebShare} from '../../utils/mockedWebLibs/react-web-share';
import {tID} from '../../utils/TestIdHelper';
import {trackEvent} from '../../utils/Analytics';
import {
  HeartFilledIcon,
  HeartIcon,
  LeftArrowIcon,
  LinkIcon,
  LongBackArrowIcon,
} from '../../utils/SvgIcons';

export const HeaderText = ({recommended = false, navigate}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      testID={tID('ViewResource-View-HeaderContainer')}
      style={styles.headerTextContainer}>
      <Text
        testID={tID('ViewResource-Text-HeaderTitle')}
        variation="Text2Medium"
        color={colors.textDisabled}
        onPress={() => navigate(-1)}>
        Resources
      </Text>
      <LeftArrowIcon style={CommonStyles.mh_12} />
      <Text
        testID={tID('ViewResource-Text-HeaderSubTitle')}
        variation="Text2SemiBold"
        color={colors.textHeading}>
        {recommended ? 'Recommended' : 'All'}
      </Text>
    </View>
  );
};

function ViewResource({route, navigation}) {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const {height} = useWindowDimensions();
  const {state} = useLocation();
  const navigate = useNavigate();
  if (Platform.OS === 'web') {
    if (!state && navigate) navigate('/resources');
    route = {params: state};
  }
  const [isFavourite, setIsFavourite] = useState(
    route.params?.data?.isFavourite,
  );
  const [uri, setUri] = useState(
    route.params?.data?.url, //temporary fix until the /test/ versus /post/ URL is fianlized for the environments
  );
  // Dlog('url is', uri);
  const lpc = useContext(loadingPauseContext);

  useEffect(() => {
    trackEvent('View Resources', {resourceid: route.params?.data?.id});
    lpc?.setVisible(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only view analytics + loader start; re-running would double-count the event
  }, []);

  const {setHeaderName} = useOutletContext();

  useLayoutEffect(() => {
    if (setHeaderName)
      setHeaderName(
        <HeaderText recommended={state?.recommended} navigate={navigate} />,
      );
  }, [setHeaderName, state?.recommended, navigate]);

  const shareTrackEvent = () => {
    trackEvent('Share Resource', {resourceid: route.params?.data?.id});
  };

  const SingleResourceHeader = () => {
    const onShare = async () => {
      try {
        shareTrackEvent();
        let content = {};
        let options = {};
        if (Platform.OS == 'ios') {
          content = {
            title: 'Share Article',
            url: uri,
          };
        } else {
          content = {
            title: 'Share Article',
            message: uri,
          };
          options = {
            dialogTitle: 'Share Article',
          };
        }
        const result = await Share.share(content, options);

        // const result = await Share.share({
        //   title: 'Share Article',
        //   url: uri,
        // });
        if (result.action === Share.sharedAction) {
          if (result.activityType) {
            // shared with activity type of result.activityType
          } else {
            // shared
          }
        } else if (result.action === Share.dismissedAction) {
          // dismissed
        }
      } catch (error) {
        alert(error.message);
      }
    };

    return (
      <View
        testID={tID('ViewResource-View-ResourceHeader')}
        style={[
          styles.flexDirectionRow,
          Platform.OS === 'web'
            ? CommonStyles.self_end
            : styles.justifyContentSpaceBetween,
        ]}>
        {Platform.OS !== 'web' && (
          <View style={styles.flexDirectionRow}>
            <IconButton
              onPress={Platform.OS === 'web' ? undefined : navigation.goBack}
              imageSize={16}
              leftImage={<LongBackArrowIcon />}
              tintColor={colors.textPrimary}
            />
            <Text
              testID={tID('ViewResource-Text-AllResources')}
              style={styles.marginHorizontal8}
              variation="Body1SemiBold"
              color={colors.textPrimary}>
              All Resources
            </Text>
          </View>
        )}
        <View style={styles.flexDirectionRow}>
          <View style={styles.marginHorizontal16}>
            <IconButton
              leftImage={isFavourite ? <HeartFilledIcon /> : <HeartIcon />}
              onPress={isFavourite ? unFavouriteAResource : favouriteAResource}
            />
          </View>
          {Platform.OS === 'web' ? (
            <Pressable style={{cursor: 'pointer'}} onPress={shareTrackEvent}>
              <RWebShare
                data={{
                  url: uri,
                  title: 'Share Article',
                }}
                onClick={() => console.log('shared successfully!')}
                style>
                <LinkIcon width={20} height={20} />
              </RWebShare>
            </Pressable>
          ) : (
            <IconButton
              leftImage={<LinkIcon />}
              imageSize={20}
              onPress={onShare}
            />
          )}
        </View>
      </View>
    );
  };

  const unFavouriteAResource = () => {
    // Dlog('unFav resource from', route.params.data);
    fetchApi(HTTP_METHODS.DELETE, UNFAV_A_RESOURCE(route.params.data.id))
      .then(res => {
        DLog('result is', res.data);
        if (Platform.OS !== 'web') {
          route.params.refreshMainList();
        }
        setIsFavourite(false);
        navigate('.', {
          replace: true,
          state: {
            data: {
              ...route.params?.data,
              isFavourite: false,
            },
          },
        });
      })
      .catch(e => DLog('error is', e));
  };
  const favouriteAResource = () => {
    // Dlog('fav resource from', route.params.data);
    fetchApi(HTTP_METHODS.POST, FAV_A_RESOURCE(route.params.data.id))
      .then(res => {
        DLog('result is', res.data);
        if (Platform.OS !== 'web') {
          route.params.refreshMainList();
        }
        setIsFavourite(true);
        navigate('.', {
          replace: true,
          state: {
            data: {
              ...route.params?.data,
              isFavourite: true,
            },
          },
        });
      })
      .catch(e => DLog('error is', e));
  };

  return Platform.OS === 'web' ? (
    <div data-testid={tID('ViewResource-div-Main')}>
      <View style={styles.margin16}>
        <SingleResourceHeader />
      </View>
      <div
        data-testid={tID('ViewResource-div-iframe')}
        style={{height: height - 162}}>
        <iframe
          onLoad={() => {
            lpc.setVisible(false);
          }}
          src={uri}
          width="100%"
          height="100%"
          style={CommonStyles.bw_0}
        />
      </div>
    </div>
  ) : (
    <SafeAreaView
      testID={tID('ViewResource-SafeAreaView-Main')}
      style={[styles.container, Platform.OS === 'web' && styles.fullScreen]}>
      <View style={styles.margin16}>
        <SingleResourceHeader />
      </View>
      <View
        testID={tID('ViewResource-View-WebView')}
        style={styles.webViewContainer}>
        <WebView
          style={styles.webView}
          source={{uri: uri}}
          onLoad={() => {
            lpc.setVisible(false);
          }}
        />
      </View>
    </SafeAreaView>
  );
}

export default ViewResource;
